import { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import styles from './TouchSensitiveHide.module.css';

export default function TouchSensitiveHide({
    children,
    disable = true,
    show = false,
    className = '',
    direction = 'down',
    time = 3000,
    ...rest
}) {
    const [isHidden, setIsHidden] = useState(false);
    const hideTimeout = useRef(null);

    // Hide the element after 3 seconds
    useEffect(() => {
        if (disable || !show) return;
        hideTimeout.current = setTimeout(() => {
            setIsHidden(true);
        }, time);

        // Clear timeout on component unmount
        return () => {
            if (hideTimeout.current) {
                clearTimeout(hideTimeout.current);
            }
        };
    }, [disable, show]);

    useEffect(() => {
        if (disable || !show) return;
        const handleTouch = () => {
            if (hideTimeout.current) {
                clearTimeout(hideTimeout.current);
            }
            setIsHidden(!isHidden);
            hideTimeout.current = setTimeout(() => {
                setIsHidden(true);
            }, time);
        };
        document.addEventListener('touchstart', handleTouch);
        return () => {
            document.removeEventListener('touchstart', handleTouch);
        };
    }, [disable, show, isHidden]);

    return (
        <div {...rest} className={`${className} ${styles.container} ${isHidden ? styles[`hidden-${direction}`] : ''}`}>
            {children}
        </div>
    );
}
